module.exports = __webpack_public_path__ + "static/media/librarian-female-caucasian.2cf01e0d.png";